/* @flow */
export const SIZE = {
  small: 'small',
  medium: 'medium',
  large: 'large'
};
